import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import AdminDashboard from "@/pages/AdminDashboard";
import GA4 from "@/components/GA4";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <GA4 />
      <ReactLenis
        root
        options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}
      >
        <div className="App bg-paper">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0D1F2D",
                color: "#F9F9F7",
                border: "1px solid rgba(212,175,55,0.35)",
                borderRadius: 0,
              },
            }}
          />
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
